export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628] via-[#0d2847] to-[#00D4FF]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-[#00D4FF] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-cyan-400 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <div className="inline-block">
              <span className="text-[#00D4FF] text-sm font-semibold tracking-[3px] uppercase">
                SECURE • PRIVATE • UNLIMITED
              </span>
            </div>
            
            <h1 className="text-6xl md:text-7xl font-bold leading-tight">
              Your Digital
              <br />
              <span className="text-[#00D4FF]">Privacy Shield</span>
            </h1>
            
            <p className="text-xl text-gray-300 leading-relaxed max-w-xl">
              Enterprise-grade VPN protection for your online freedom and security. Browse anonymously, access content worldwide, and protect your data.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-[#00D4FF] to-[#0A1628] text-white px-8 py-4 rounded-full font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Start Free Trial
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollToSection('vpn-services')}
                className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-[#0A1628] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="relative w-full h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/09c3ee8144a26dfa8cb1a06dc3a9b4ef.jpg"
                alt="Global VPN Network"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
